/**
 * arfolyam service az árfolyamok lekérdezéshez tartozó servie
 * @author István Rózsa 2017.05.16.
 */
import moment from 'moment';
const MODULE_NAME = 'arfolyamService';
class ArfolyamService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
		this.apiRoot = '/api';
	}
	getAktualisArfolyamok() {
		return this.$http.get(`${this.apiRoot}/arfolyam/aktualis`);
	}
	getTekozForInterval(dates) {
		return this.$http.post(`${this.apiRoot}/arfolyam/tekoz`, dates);
	}
	getArfolyam(dates) {
		return this.$http.post(`${this.apiRoot}/arfolyam`, dates);
	}
	getTekozInitDates() {
		return this.$http.get(`${this.apiRoot}/arfolyam/tekoz/init`);
	}
	getTekozForDate() {
		return this.$http.get(`${this.apiRoot}/arfolyam/tekoz`);
	}
	getSzolgaltatasForDate() {
		return this.$http.get(`${this.apiRoot}/arfolyam/szolgaltatasi`);
	}
	getSzolgaltatasiForDate(date) {
		return this.$http.get(`${this.apiRoot}/arfolyam/szolgaltatasi`);
	}
	getGrafikonInitDates() {
		return this.$http.get(`${this.apiRoot}/arfolyam/init`);
	}

	getPortfolioChartAdatok(responseData) {

		if (responseData.portfolios.length && responseData.portfolios[0].data.length < 2) {
			return null;
		}

		let colors = ['#52ae30', '#8946ae', '#ff6600', '#84ff8c', '#2950ff', '#1bffed'];
		let reformattedDataArray = responseData.dates.map(function (date) {
			let monthForUtc = parseInt(date.substring(4, 6)) - 1; // hónapok számozását az UTC 0-val kezdi
			return Date.UTC(date.substring(0, 4), monthForUtc, date.substring(6, 8));
		});

		let graphSeries = [];
		let graphData = [];
		for (let j = 0; j < responseData.portfolios.length; j++) {
			for (let i = 0; i < reformattedDataArray.length; i++) {
				graphData.push([reformattedDataArray[i], responseData.portfolios[j].data[i]]);
			}
			let obj = {
				name: responseData.portfolios[j].name,
				data: graphData,
				color: colors[j],
				linkedTo: j
			};

			let linkedObj = {
				data:[],
				name: responseData.portfolios[j].name,
				id: j,
				color: colors[j],
				marker: {
					enabled: true,
					symbol: 'square',
					radius: 10
				}
			};

			graphSeries.push(obj);
			graphSeries.push(linkedObj);
			graphData = [];
		}

		return {
			chart: {
				type: 'line',
				marginTop: 60
			},
			plotOptions: {
				series: {
					marker: {
						enabled: false
					},
					events: {
						legendItemClick: function () {
							return false;
						}
					}
				}
			},
			title: {
				text: ''
			},
			yAxis: {
				title: {
					text: ''
				},
				opposite: true
			},
			xAxis: {
				type: 'datetime',
				title: {
					text: ''
				},
				labels: {
					formatter: function () {
						return moment(this.value).format("YYYY.MM.DD");
					}
				}
			},
			tooltip: {
				headerFormat: '<b>{series.name}</b><br>',
				pointFormat: '{moment(point.x).format("YYYY.MM.DD")}{point.y:.2f}',
				formatter: function () {
					let formattedDate = moment(this.x).format('YYYY.MM.DD');
					return `<span style="font-size=10">${formattedDate}</span><br/>
							<span style="color:${this.color}">●</span>
							<span style="font-weight:bold">${this.y}</span>`;
				}
			},
			legend: {
				align: 'left',
				verticalAlign: 'bottom',
				backgroundColor: '#FFFFFF',
				itemMarginBottom: 10
			},
			series: graphSeries
		};
	}
}

export default angular.module(MODULE_NAME, []).service('arfolyamService', ArfolyamService).name;



// WEBPACK FOOTER //
// ../source/application/services/arfolyam-service.js